// src/App.js

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";

import UserList from "./pages/Account/UserList";
import Register from "./pages/Account/Register";
import Profile from "./pages/Account/Profile";
import EditUser from "./pages/Account/EditUser";

import CallLogs from "./pages/CallLogs/CallLogs";
import DailerRecoring from "./pages/CallLogs/DailerRecoring/RecordingIndex";
import ConsultationReport from "./pages/ConsultationReport/ConsultationReport";
import TabeebReporting from "./pages/Tabeeb/TabeebReporting";

import BlogsList from "./pages/Blogs/BlogsList";
import BlogDetails from "./pages/Blogs/BlogDetails";
import CreateBlog from "./pages/Blogs/CreateBlog";
import EditBlog from "./pages/Blogs/EditBlog";

import ProtectedRoute from "./components/ProtectedRoute";

import Apnaclinic from "./pages/ApnaClinic/BlockedNumbers";
import Pbx4455Sync from "./pages/ApnaClinic/Pbx4455Sync";
import BulkRegistrationReport from "./pages/Digi_Insurance/BulkRegistrationReport";
import BulkRegistrationDashboard from "./pages/Digi_Insurance/BulkRegistration_Dashboard";
import SqlStudio from "./sql-studio/SqlStudio";
import { SQL_STUDIO_ROUTE } from "./sql-studio/constants";
import OfficeProjects from "./pages/OfficeLinks/OfficeProjects";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ── Auth ── */}
        <Route path="/" element={<Login />} />



        {/* ── Dashboard ── */}
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

        {/* ── Accounts ── */}
        <Route path="/account/users" element={<ProtectedRoute><UserList /></ProtectedRoute>} />
        <Route path="/account/register" element={<ProtectedRoute><Register /></ProtectedRoute>} />
        <Route path="/account/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/account/edit/:id" element={<ProtectedRoute><EditUser /></ProtectedRoute>} />

        {/* ── Reporting ── */}
        <Route path="/reporting/call-logs" element={<ProtectedRoute><CallLogs /></ProtectedRoute>} />
        <Route path="/reporting/consultation-report" element={<ProtectedRoute><ConsultationReport /></ProtectedRoute>} />
        <Route path="/reporting/dailer-recording" element={<ProtectedRoute><DailerRecoring /></ProtectedRoute>} />
        <Route path="/reporting/tabeeb" element={<ProtectedRoute><TabeebReporting /></ProtectedRoute>} />

        {/* ── Blogs ── */}
        <Route path="/blogs" element={<ProtectedRoute><BlogsList /></ProtectedRoute>} />
        <Route path="/blogs/create" element={<ProtectedRoute><CreateBlog /></ProtectedRoute>} />
        <Route path="/blogs/edit/:id" element={<ProtectedRoute><EditBlog /></ProtectedRoute>} />
        <Route path="/blogs/:id" element={<ProtectedRoute><BlogDetails /></ProtectedRoute>} />

        {/* ── ApnaClinic ── */}

        <Route path="/Pages/ApnaClinic/pbx-4455-sync" element={<ProtectedRoute><Pbx4455Sync /></ProtectedRoute>} />
        <Route path="/Pages/ApnaClinic" element={<ProtectedRoute><Apnaclinic /></ProtectedRoute>} />


        {/* ── Digi_Insurance ── */}
        <Route path="/Pages/BulkRegistrationReport" element={<ProtectedRoute><BulkRegistrationReport /></ProtectedRoute>} />
        <Route path="/Pages/BulkRegistration_Dashboard" element={<ProtectedRoute><BulkRegistrationDashboard /></ProtectedRoute>} />

        {/* ── SQL Studio (portable module) ── */}
        <Route path={SQL_STUDIO_ROUTE} element={<ProtectedRoute><SqlStudio /></ProtectedRoute>} />

        {/* ── Office LAN project bookmarks ── */}
        <Route path="/tools/office-projects" element={<ProtectedRoute><OfficeProjects /></ProtectedRoute>} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;